import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ColDef, ColGroupDef } from '@ag-grid-community/core';
import { LiteratureDocumentListingData } from '@types';

@Component({
  selector: 'ft-fund-document-card-container',
  templateUrl: './fund-document-card-container.component.html',
  styleUrls: ['./fund-document-card-container.component.scss'],
})
export class FundDocumentCardContainerComponent {
  @Input() rowData: LiteratureDocumentListingData[];
  @Input() columnDefs: (ColDef | ColGroupDef)[];
  @Input() gridContext: any;
  @Output()
  selectionEmitter = new EventEmitter<LiteratureDocumentListingData>();

  onSelectionChanged(event) {
    this.selectionEmitter.emit(event);
  }
}
